import TopBar from '../../components/Layout/TopBar';
import ClipLoader from 'react-spinners/ClipLoader';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faCircleCheck, faCircleXmark, faList, faPen, faPlus, faTrash, faUndo,} from '@fortawesome/free-solid-svg-icons';
import MyDialog from '../../components/Layout/MyDialog';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import axios from 'axios';
import {URL_API} from '../../utils/globalConfig';
import {logError} from '../../components/Utils/FormatData';
import useAuthz from '../../hooks/useAuthz';
import {useAlert} from 'react-alert';
import MySelect from "../../components/Layout/MySelect";
import MyButton from "../../components/Layout/MyButton";

const gestionReferentielStyle = {
    cellHeader: {fontSize: '12px', color: 'white', border: '0', borderRight: '1px solid #ffffff4d', textTransform: 'uppercase'},
    rowDeleted: {backgroundColor: '#5a6e7430'},
    iconTable: {color: '#bb0060', height: '13px', padding: '0 10px', cursor: 'pointer'},
    classicInput: {border: 'none', outline: 'none', width: '90%'},
    classicSelect: {border: 'none', outline: 'none', width: '200px'}
};

const Referentiel = (props) => {
    const alert = useAlert();
    const navigate = useNavigate();
    const [listeReferentiels, setListeReferentiels] = useState([]);
    const [deletedSelected, setDeletedSelected] = useState({newDeletedSelected: 1, editedDeletedSelected: 1});
    const [isLoading, setIsLoading] = useState(true);
    const [content, setContent] = useState('');
    const [dialogData, setDialogData] = useState({type: '', data: {}});
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogState, setDialogState] = useState(null);
    const [authz, user, profil] = useAuthz();
    const [edition, setEdition] = useState(false)
    const [elementToEdit, setElementToEdit] = useState({key: null, value: null})
    const [selectedValue, setSelectedValue] = useState({filterSelected: 1});
    const [needReload, setNeedReload] = useState(false)
    const [referentiel, setReferentiel] = useState({editedNom: '', editedDescription: '', newNom: '', newDescription: ''})

    //#region useEffect

    useEffect(() => {
        if (dialogState && dialogData.data) {

            switch (dialogData.type) {
                case 'delete':
                    callApiDelete(dialogData.data);
                    break;
                case 'activate':
                    callApiActivate(dialogData.data);
                    break;
            }
        }
        setDialogState(null);
    }, [dialogState]);
    useEffect(() => {
        if (needReload) {
            getListeReferentiels();
            setNeedReload(false);
        }
    }, [needReload]);
    useEffect(() => {
        if (profil.profil === 6) {
            alert.error('Vous n\'êtes pas autorisé à accéder à la page de création des référentiels');
            navigate('/');
        }
        document.title = 'TE - Gestion des référentiels';
        getListeReferentiels();
    }, []);

    //#endregion

    //#region Fonctions

    const addNewReferential = () => {
        let valueIsValid = true;
        let name = referentiel.newNom;
        let descr = referentiel.newDescription;
        let deleted = deletedSelected.newDeletedSelected === 2;

        if (name === '' || deleted === '' || descr === '') {
            alert.error('Vous devez remplir les champs avant de continuer !');
            valueIsValid = false;
        } else {
            listeReferentiels.map((elt) => {
                if (elt.name === name.trim()) {
                    alert.error('Un élément ayant le même nom existe déjà !');
                    valueIsValid = false;
                }
            });
            if (valueIsValid) {
                callApiAdd({
                    name: name.trim(),
                    description: descr.trim(),
                    deleted: deleted,
                    metadata: []
                })
            }
        }

        resetForm();
    };
    const handleOnDelete = (element) => {
        setDialogData({...dialogData, data: element, type: 'delete'});
        setContent(() => {
            return (
                <>
                    <div>Êtes-vous sur de vouloir supprimer le référentiel : <b>{element.name}</b> ?</div>
                </>
            )
        });
        setOpenDialog(true);
    };
    const handleOnActivate = (element) => {
        setDialogData({...dialogData, data: element, type: 'activate'});
        setContent(() => {
            return (
                <>
                    <div>Êtes-vous sur de vouloir réactiver le référentiel : <b>{element.name}</b> ?</div>
                </>
            )
        });
        setOpenDialog(true);
    };
    const handleOnEdit = (element) => {
        setElementToEdit(element);
        setReferentiel({editedNom: element.name, editedDescription: element.description})
        setEdition(!edition);
    };
    const handleOnEditValidate = (elementToEdit) => {
        let obj = {
            id: elementToEdit.id,
            name: referentiel.editedNom,
            description: referentiel.editedDescription,
            deleted: deletedSelected.editedDeletedSelected === 2
        }
        if (obj.id === null || obj.name === '' || obj.description === '') {
            alert.error("Vous devez remplir tous les champs avant de valider ! ")
        } else {
            callApiEdit(obj)
            setEdition(!edition);
        }
    }
    const resetForm = () => {
        document.getElementById('newName').value = '';
        document.getElementById('newDescr').value = '';
    }
    const changeSelectedDeletedValue = (e) => {
        setDeletedSelected({...deletedSelected, [e.target.name]: e.target.value})
        setNeedReload(true)
    };

    const changeValue = (e) => {
        setReferentiel({...referentiel, [e.target.name]: e.target.value})
    };
    //#endregion

    //#region API

    const getListeReferentiels = () => {
        let tabReferentiels = [];
        let deleted;
        if (selectedValue.filterSelected === 3) deleted = ''; else deleted = selectedValue.filterSelected !== 1;
        const promiseListReferentiels = axios({method: 'get', url: `${URL_API}/referentiel/full-list`, params: {deleted: deleted}});
        Promise.all([promiseListReferentiels])
            .then(function (values) {
                values[0].data.forEach(elt => tabReferentiels.push({id: elt.id, name: elt.name, description: elt.description, deleted: elt.deleted}))
                setListeReferentiels(tabReferentiels);
                setIsLoading(false);
            })
            .catch(function (err) {
                logError(alert, err);
            });
    };
    const callApiAdd = (referentiel) => {
        axios({method: 'post', url: `${URL_API}/referentiel/add`, data: referentiel, params: {userAction: user.user_id}})
            .then(() => {
                alert.removeAll();
                alert.success('L\'ajout a bien été effectuée ! ');
                setNeedReload(true)
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.response.data.message);
            });
    };
    const callApiDelete = (referentiel) => {
        axios({method: 'post', url: `${URL_API}/referentiel/delete`, params: {id: referentiel.id, userAction: user.user_id}})
            .then(() => {
                alert.removeAll();
                alert.success('La suppression a bien été effectuée ');
                setNeedReload(true)
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.response.data.message);
            });
    };
    const callApiActivate = (referentiel) => {
        axios({method: 'post', url: `${URL_API}/referentiel/activate`, params: {id: referentiel.id, userAction: user.user_id}})
            .then(() => {
                alert.removeAll();
                alert.success('L\'activation a bien été effectuée ! ');
                setNeedReload(true);
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.response.data.message);
            });
    };
    const callApiEdit = (referentiel) => {
        axios({method: 'post', url: `${URL_API}/referentiel/edit`, data: referentiel, params: {userAction: user.user_id}})
            .then(() => {
                alert.removeAll();
                alert.success('L\'édition a bien été effectuée ! ');
                setNeedReload(true);
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.response.data.message);
            });
    };

    const changeSelectValue = (e) => {
        setSelectedValue({...selectedValue, [e.target.name]: e.target.value})
        setNeedReload(true)
    };

    //#endregion

    return (
        <div style={{height: 'calc(100% - 50px)'}}>
            <TopBar title="Gestion des référentiels" className='topbar-contenu' color={props.params.color}
                    filterContainer={
                        <>
                            <MySelect name={"filterSelected"} label={"Filtre"}
                                      datas={[{key: 1, value: 'Référentiels activés'}, {key: 2, value: 'Référentiels archivés'}]}
                                      style={gestionReferentielStyle.classicSelect} firstValue={{key: 3, value: 'Tous les référentiels'}}
                                      value={selectedValue.filterSelected} handleChange={changeSelectValue}/>
                        </>
                    }
                    buttons={
                        <div className='topbar-buttons'>
                            <MyButton onClick={() => navigate("/panneau-administration")} icon={''} label={'Retour'}/>
                        </div>
                    }
            />

            <div className='row' style={{margin: 0, overflow: 'hidden'}}>
                <ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>
                {!isLoading && (
                    <Paper style={{height: '100%', width: '100%', borderTop: '1px solid #4db4da'}}>
                        <TableContainer component={Paper} style={{overflow: 'auto', height: '100%'}}>
                            <Table aria-label="simple table">
                                <TableHead style={{backgroundColor: '#0094ca'}}>
                                    <TableRow>
                                        <TableCell align="center" style={gestionReferentielStyle.cellHeader}>Actions</TableCell>
                                        <TableCell align="center" style={gestionReferentielStyle.cellHeader}>Nom</TableCell>
                                        <TableCell align="center" style={gestionReferentielStyle.cellHeader}>Description</TableCell>
                                        <TableCell align="center" style={gestionReferentielStyle.cellHeader}>Données</TableCell>
                                        <TableCell align="center" style={gestionReferentielStyle.cellHeader}>Activé</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {listeReferentiels.map((element, index) => (
                                        <TableRow key={"row-" + index} style={element.deleted ? gestionReferentielStyle.rowDeleted : null}>
                                            <TableCell align="center">
                                                {edition && element.id === elementToEdit.id ?
                                                    <FontAwesomeIcon icon={faCheck} style={gestionReferentielStyle.iconTable} onClick={() => handleOnEditValidate(element)}/> :
                                                    <>{element.deleted ? '' :
                                                        <FontAwesomeIcon icon={faPen} style={gestionReferentielStyle.iconTable} onClick={() => handleOnEdit(element)}/>}</>
                                                }
                                                {element.deleted ?
                                                    <FontAwesomeIcon icon={faUndo} style={gestionReferentielStyle.iconTable} onClick={() => handleOnActivate(element)}/> :
                                                    <FontAwesomeIcon icon={faTrash} style={gestionReferentielStyle.iconTable} onClick={() => handleOnDelete(element)}/>
                                                }
                                            </TableCell>
                                            <TableCell align="left" style={{color: element.deleted ? '#a7a7a7' : ''}}>
                                                {edition && element.id === elementToEdit.id ?
                                                    <TextField type="text" name="editedNom" id="editedName" value={referentiel.editedNom || ''} onChange={changeValue}
                                                               style={gestionReferentielStyle.classicInput}/> :
                                                    <TextField fullWidth={true} inputProps={{readOnly: true}} value={element.name}
                                                               style={gestionReferentielStyle.classicInput}></TextField>
                                                }
                                            </TableCell>
                                            <TableCell align="left" style={{color: element.deleted ? '#a7a7a7' : ''}}>
                                                {edition && element.id === elementToEdit.id ?
                                                    <TextField type="text" name="editedDescription" id="editedDesc" value={referentiel.editedDescription || ''}
                                                               onChange={changeValue}
                                                               style={gestionReferentielStyle.classicInput}/> :
                                                    <TextField fullWidth={true} inputProps={{readOnly: true}} value={element.description}
                                                               style={gestionReferentielStyle.classicInput}></TextField>
                                                }
                                            </TableCell>
                                            {element.deleted ?
                                                <TableCell align="center"/> :
                                                <TableCell align="center">
                                                    <FontAwesomeIcon icon={faList} style={gestionReferentielStyle.iconTable}
                                                                     onClick={() => navigate('/panneau-administration/referentiel/gestion?name=' + element.name)}
                                                    />
                                                </TableCell>
                                            }
                                            {element.deleted ?
                                                <TableCell align="center">
                                                    {edition && element.id === elementToEdit.id ?
                                                        <MySelect name={"editedDeletedSelected"} label={"Activé"} style={gestionReferentielStyle.classicInput}
                                                                  value={element.editedDeletedSelected}
                                                                  datas={[{key: 1, value: "Activé"}, {key: 2, value: "Archivé"}]} handleChange={changeSelectedDeletedValue}
                                                                  disableClass={true}
                                                                  displayLabel={true}>
                                                        </MySelect> :
                                                        <FontAwesomeIcon icon={faCircleXmark} style={{color: "#bb0060", height: '20px'}}/>
                                                    }
                                                </TableCell> :
                                                <TableCell align="center">
                                                    {edition && element.id === elementToEdit.id ?
                                                        <MySelect name={"editedDeletedSelected"} label={"Activé"} style={gestionReferentielStyle.classicInput}
                                                                  value={deletedSelected.editedDeletedSelected}
                                                                  datas={[{key: 1, value: "Activé"}, {key: 2, value: "Archivé"}]} handleChange={changeSelectedDeletedValue}
                                                                  disableClass={true}
                                                                  displayLabel={true}>
                                                        </MySelect> :
                                                        <FontAwesomeIcon icon={faCircleCheck} style={{color: "#a5c946", height: '20px'}}/>
                                                    }
                                                </TableCell>
                                            }
                                        </TableRow>
                                    ))
                                    }
                                    <TableRow>
                                        <TableCell align="center">
                                            <FontAwesomeIcon icon={faPlus} style={gestionReferentielStyle.iconTable} onClick={() => addNewReferential()}/>
                                        </TableCell>
                                        <TableCell align="left"><TextField onChange={changeValue} label={'Nom'} type="text" name="newName" id="newName"
                                                                           style={gestionReferentielStyle.classicInput}></TextField></TableCell>
                                        <TableCell align="left"><TextField onChange={changeValue} label={'Description'} type="text" name="newDescription" id="newDescr"
                                                                           style={gestionReferentielStyle.classicInput}></TextField></TableCell>
                                        <TableCell align="center"/>
                                        <TableCell align="center">
                                            <MySelect name={"newDeletedSelected"}
                                                      label={"Statut"}
                                                      style={gestionReferentielStyle.classicSelect}
                                                      value={deletedSelected.newDeletedSelected}
                                                      datas={[{key: 1, value: "Activé"}, {key: 2, value: "Archivé"}]}
                                                      handleChange={changeSelectedDeletedValue}
                                                      disableClass={true}
                                                      displayLabel={true}
                                            >
                                            </MySelect>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                )}
            </div>

            <MyDialog open={openDialog} handleClose={setOpenDialog} title='Gestion référentiel' content={content} dialog={setDialogState}/>
        </div>
    );
}

export default Referentiel;
